<template>
    <page-base>
        <template slot="content">
            <b-card>
                <b-alert variant="danger" :show="showAlert">
                    {{ alert }}
                </b-alert>
                <b-alert variant="success" :show="showSuccessAlert">
                    {{ alert }}
                </b-alert>
                <b-form @submit.prevent="operationType === 'add' ? createAddress() : updateAddress()">
                    <b-form-group :label="$t('addressInfo.operationType')">
                        <b-form-radio-group v-model="operationType">
                            <b-form-radio value="add">{{ $t('general.add') }}</b-form-radio>
                            <b-form-radio value="edit">{{ $t('general.edit') }}</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('addressInfo.selectType', [$t(`general.${operationType}`).toLowerCase()])">
                        <multiselect v-model="selectedPointType" :options="pointTypes" :allow-empty="false"
                                    :close-on-select="true" :hide-selected="true" :show-no-results="false"
                                    :preselect-first="true" label="name" :placeholder="$t('general.select')" :select-label="''">
                            <template slot="noOptions">
                                <span>
                                    {{ $t('general.enterValue' )}}
                                </span>
                            </template>
                        </multiselect>
                    </b-form-group>
                    <b-form-group :label="$t('addressInfo.area')">
                        <multiselect v-model="selectedObjects['Region']" :options="collections['Region']" @input="addressSelected"
                                    :close-on-select="true" :hide-selected="true" :showNoResults="false"
                                    label="name" :placeholder="$t('general.select')" :select-label="''">
                            <template slot="noOptions">
                                <span>
                                    {{ $t('general.enterValue' )}}
                                </span>
                            </template>
                        </multiselect>
                    </b-form-group>
                    <b-form-group v-if="collections['RegionDistrict'].length > 0" :label="$t('addressInfo.district')">
                        <multiselect v-model="selectedObjects['RegionDistrict']" :options="collections['RegionDistrict']" @input="addressSelected"
                                    :close-on-select="true" :hide-selected="true" :showNoResults="false"
                                    label="name" :placeholder="$t('general.select')" :select-label="''">
                            <template slot="noOptions">
                                <span>
                                    {{ $t('general.enterValue' )}}
                                </span>
                            </template>
                        </multiselect>
                    </b-form-group>
                    <b-form-group v-if="collections['City'].length > 0" :label="$t('addressInfo.city')">
                        <multiselect v-model="selectedObjects['City']" :options="collections['City']" @input="addressSelected"
                                    :close-on-select="true" :hide-selected="true" :showNoResults="false"
                                    label="name" :placeholder="$t('general.select')" :select-label="''">
                            <template slot="noOptions">
                                <span>
                                    {{ $t('general.enterValue' )}}
                                </span>
                            </template>
                        </multiselect>
                    </b-form-group>
                    <b-form-group v-if="collections['CityDistrict'].length > 0" :label="$t('addressInfo.cityDistrict')">
                        <multiselect v-model="selectedObjects['CityDistrict']" :options="collections['CityDistrict']" @input="addressSelected"
                                    :close-on-select="true" :hide-selected="true" :showNoResults="false"
                                    label="name" :placeholder="$t('general.select')" :select-label="''">
                            <template slot="noOptions">
                                <span>
                                    {{ $t('general.enterValue' )}}
                                </span>
                            </template>
                        </multiselect>
                    </b-form-group>
                    <b-form-group v-if="collections['Microdistrict'].length > 0" :label="$t('addressInfo.microDistrict')">
                        <multiselect v-model="selectedObjects['Microdistrict']" :options="collections['Microdistrict']" @input="addressSelected"
                                    :close-on-select="true" :hide-selected="true" :showNoResults="false"
                                    label="name" :placeholder="$t('general.select')" :select-label="''">
                            <template slot="noOptions">
                                <span>
                                    {{ $t('general.enterValue' )}}
                                </span>
                            </template>
                        </multiselect>
                    </b-form-group>
                    <b-form-group v-if="collections['Street'].length > 0" :label="$t('addressInfo.street')">
                        <multiselect v-model="selectedObjects['Street']" :options="collections['Street']" @input="addressSelected"
                                    :close-on-select="true" :hide-selected="true" :showNoResults="false"
                                    label="name" :placeholder="$t('general.select')" :select-label="''">
                            <template slot="noOptions">
                                <span>
                                    {{ $t('general.enterValue' )}}
                                </span>
                            </template>
                        </multiselect>
                    </b-form-group>
                    <b-form-group v-if="collections['House'].length > 0" :label="$t('addressInfo.house')">
                        <multiselect v-model="selectedObjects['House']" :options="collections['House']" @input="addressSelected"
                                    :close-on-select="true" :hide-selected="true" :showNoResults="false"
                                    label="name" :placeholder="$t('general.select')" :select-label="''">
                            <template slot="noOptions">
                                <span>
                                    {{ $t('general.enterValue' )}}
                                </span>
                            </template>
                        </multiselect>
                    </b-form-group>
                    <b-form-group :label="$t('addressInfo.newValue')">
                        <b-form-input v-model="formData.value"></b-form-input>
                    </b-form-group>
                    <b-form-row class="justify-content-end mx-0">
                        <b-button type="submit" variant="success" :disabled="isDisabled">
                            <save-icon title="" />&nbsp;{{ $t('general.save') }}
                        </b-button>
                    </b-form-row>
                </b-form>
            </b-card>
        </template>
    </page-base>
</template>

<script>
/* eslint-disable */
import AppData from '@/utils/appdata';

export default {
    name: 'AddressInfo',
    mixins: [AppData],
    created () {
        this.getPoints()
    },
    data () {
        return {
            showAlert: false,
            showSuccessAlert: false,
            alert: '',
            formData: {
                parentId: null,
                pointId: null,
                type: null,
                value: null
            },
            selectedPointType: null,
            operationType: 'add',
            collections: {
                'Region': [],
                'RegionDistrict': [],
                'City': [],
                'CityDistrict': [],
                'Microdistrict': [],
                'Street': [],
                'House': []
            },
            selectedObjects: {
                'Region': null,
                'RegionDistrict': null,
                'City': null,
                'CityDistrict': null,
                'Microdistrict': null,
                'Street': null,
                'House': null
            }
        }
    },
    computed: {
        isDisabled: function () {
            return this.$store.getters.isLoading
        },
        pointTypes: function () {
            if (this.isAdmin) {
                return [
                    { id: 'House', name: this.$t('addressInfo.house') },
                    { id: 'RegionDistrict', name: this.$t('addressInfo.district') },
                    { id: 'City', name: this.$t('addressInfo.city') },
                    { id: 'CityDistrict', name: this.$t('addressInfo.cityDistrict') },
                    { id: 'Microdistrict', name: this.$t('addressInfo.microDistrict') },
                    { id: 'Street', name: this.$t('addressInfo.street') }
                ];
            }

            return [
                { id: 'House', name: this.$t('addressInfo.house') },
                { id: 'Street', name: this.$t('addressInfo.street') }
            ]; 
        }
    },
    watch: {
        selectedPointType: function (newVal) {
            this.formData.type = newVal.id;

            this.clearChilds('Region');
            this.selectedObjects['Region'] = null;
        },
        operationType: function () {
            this.clearChilds('Region')
            if (this.selectedObjects['Region'] != null) {
                this.addressSelected(this.selectedObjects['Region'])
            }
        }
    },
    methods: {
        getPoints: function () {
            const onSuccess = response => {
                this.collections['Region'] = response.filter(x => x.type === 'Region' || x.type === 'City' && x.parentId == null);
            };

            this.$request.sendRequest(
                this,
                this.$appConfig.apiUrls.info.point,
                null,
                onSuccess,
                this.displayAlert);
        },
        createAddress: function () {
            this.hideAlert()
            this.$request.sendRequest(this, this.$appConfig.apiUrls.info.createAddress,
                this.formData, result => {
                    this.showSuccessAlert = true
                    this.alert = this.$i18n.t('addressInfo.addressCreatedMessage')
                }, this.displayAlert)
        },
        updateAddress: function () {
            this.hideAlert()
            this.$request.sendRequest(this, this.$appConfig.apiUrls.info.updateAddress,
                this.formData, result => {
                    this.showSuccessAlert = true
                    this.alert = this.$i18n.t('addressInfo.addressUpdatedMessage')
                }, this.displayAlert)
        },
        hideAlert: function () {
            this.showAlert = false
            this.showSuccessAlert = false
            this.alert = ''
        },
        displayAlert: function (errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`)
            this.showAlert = true
        },
        addressSelected: function (selectedAddress) {
            this.clearChilds(selectedAddress.type);

            this.lastSelectedAddress = selectedAddress;

            this.formData.parentId = this.operationType === 'add' 
                ? selectedAddress.id 
                : selectedAddress.parentId;

            this.formData.pointId = selectedAddress.id;
            
            const onSuccess = response => {
                for(let point of response){
                    if (this.collections[point.type].some(e => e.id === point.id) || !this.isAllowedPointType(point.type))
                        continue;
                        
                    this.collections[point.type].push(point);
                }
            };

            this.$request.sendRequest(
                this, 
                this.$appConfig.apiUrls.info.point,
                { parentId: selectedAddress.id },
                onSuccess,
                this.displayAlert);
        },
        clearChilds(type) {
            _clearMembers(this.selectedObjects, type, false);
            _clearMembers(this.collections, type, true);
        },
        isAllowedPointType(type) {
            const PointTypeLevel = {
                Region: 1,
                RegionDistrict: 2,
                City: 3,
                CityDistrict: 4,
                Microdistrict: 5,
                Street: 6,
                House: 7
            };

            return PointTypeLevel[type] < PointTypeLevel[this.selectedPointType.id] && this.operationType === 'add'
                    || PointTypeLevel[type] <= PointTypeLevel[this.selectedPointType.id] && this.operationType === 'edit';
        }
    }
} 

function _clearMembers(collections, afterThat, isArray) {
    const keys = Object.keys(collections);
    
    let clear = false;

    for(let i = 0; i < keys.length; i++){
        if (keys[i] === afterThat){
            clear = true;
            continue;
        }
        
        if (clear)
            collections[keys[i]] = isArray === true ? [] : null;
    }
}
</script>
